import { createSlice } from '@reduxjs/toolkit'

const homepageStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    status: homepageStatus.LOADING,
    posts: [],
}

const homepageSlice = createSlice({
    name: 'homepage',
    initialState,
    reducers: {
        getPostsRequest: state => {
            state.status = homepageStatus.LOADING
        },
        getPostsRequestSuccess: (state, action) => {
            state.status = homepageStatus.SUCCESS
            state.posts = action.payload
        },
        getPostsRequestError: state => {
            state.status = homepageStatus.FAILURE
        },
    },
})

const {
    getPostsRequest,
    getPostsRequestSuccess,
    getPostsRequestError,
} = homepageSlice.actions

export const homepageActions = {
    getPostsRequest,
    getPostsRequestSuccess,
    getPostsRequestError,
}

export const homepageSelectors = {
    isFetching: state => state.homepage.status === homepageStatus.LOADING,
    hasError: state => state.homepage.status === homepageStatus.FAILURE,
    posts: state => state.homepage.posts,
}

export const homepageReducer = homepageSlice.reducer
